import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-all-task-status-wise',
  templateUrl: './all-task-status-wise.component.html',
  styleUrls: ['./all-task-status-wise.component.css']
})
export class AllTaskStatusWiseComponent implements OnInit {

  usersList: any= []
  cid:any
  userTasks: any = []
  user:any = ""


  i: any;
  deleteId: any;
  id: any;
  task:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  assignInput = ""
  addClassType = ""
  statusNote = false;
  statusNoteText = ""
  userIdList = [];
  taskType = "All"
  page: number = 0;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  taskMasters:any = []
  ticketId = ''
  ctid:any = "";
  TicketData: any = []
  imageSingle: any = ""
  videoSingle: any = ""
  vv: any = ""
  updatebutton:any = false

  constructor(private router: Router,private _sanitizer: DomSanitizer,private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  fileType:any;
  file = '';
  tasks:any = []
  images:any= [];
  videos:any= [];
  audios:any= [];
  name = ""
  description = ""
  assignedTo = ""
  searchFilter = ''
  taskId = ""
  note = ""
  taskStatus = ""

  NEW_tasksCount = 0
  ASSIGNED_tasksCount = 0
  REASSIGNED_tasksCount = 0
  WORK_IN_PROGRESS_tasksCount = 0
  PENDING_tasksCount = 0
  COMPLETED_tasksCount = 0
  DEFERRED_tasksCount = 0
  PARTIALLY_COMPLETED_tasksCount = 0
  FORCE_CLOSED_tasksCount = 0
  CLOSED_tasksCount = 0
  Total_tasksCount = 0

  taskPercentage = ""
  task_active_or_inactive = "NEW"
  usersWithoutCustomers:any = []
  
  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    this.getUsersWithoutCustomers()
    // this.getAllTask()
    this.getActiveOrInactiveTasks(this.task_active_or_inactive)
    this.form = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });

  }

  getAllTaskStatusWiseByAssignedToId(id:any,name:any){
    this.generic_service.getAllTaskStatusWiseByAssignedToId(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.userTasks = res.response;
        this.user = name

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }  
  
  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersWithoutCustomers = res.response;
        this.usersList = res.response;
        this.user = this.usersList[0].userName
        this.getAllTaskStatusWiseByAssignedToId(this.usersList[0].userId,this.usersList[0].userName)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event;
    console.log(event);
    if(this.task_active_or_inactive == 'All'){
      this.getAllTask()
    }
    else if(this.task_active_or_inactive == 'Active'){
      this.getAllActiveTask(Number(this.page),10)
    }else if(this.task_active_or_inactive == 'In-active'){
      this.getAllNonActiveTask(Number(this.page),10)
    }else{

    }
    // this.getAllTask();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    // this.getAllTask();
  }


  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.tagUsersdropdownList = res.response;
        console.log(res);
      }
    )
  }

  addTask(){
    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if(this.form.get('assignedTo').value == ''){
      status = "NEW"
    }else{
      status = "ASSIGNED"
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "taskRegType": "string",
      "taskRegId": "string",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.form.get('assignedTo').value),
      "taskExpStartDate": new Date(this.form.get('taskExpStartDate').value).getTime(),
      "taskExpEndDate": new Date(this.form.get('taskExpEndDate').value).getTime(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "string",
          "taskStatus": status,
          "updatedDate": 0
        }
      ],
      "completedPercentage": 0,
      "notes": "string",
      "audio": this.audios,
      "video": this.videos,
      "image": this.images,
      "tagUserIds": tagUserIds,
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addTask(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTask()
        this.clearForm()
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton12")?.click()
  }

  getAllTask(){
    // this.taskType = "All"
    // this.generic_service.getAllTask().subscribe(
    //   (response:any)=>{
    //     console.log(response)
    //     this.tasks = response.response;
    //     this.count = response.response.length

    //   }
    // )
  }

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn(){
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn(){
    document.getElementById("add-audio-btn")?.click()
  }

  editskill(){
    this.tasks[this.i].name=this.name
    this.tasks[this.i].description=this.description
    this.tasks[this.i].assignedTo = this.assignedTo;
    this.close()
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.description = ""
    this.assignedTo = ""
  }
  
  edit(i:any){
    this.open();
  }

  deleteTask(){
    this.generic_service.delTask(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success(res.message);
        this.getAllTask();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);         
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  statusDropdown(){
    if(this.task[0].assignedTo == '' || this.task[0].assignedTo == null){
      this.addClass('assignedTo')
    }else{
      if(this.statusNote == true){
        this.statusNote = false;
      }else{
        this.statusNote = true;
      }
    }

  }
  taskAssignToUser(taskId:any, userId: any,taskStatus:any,name:string){
    let note = "";
    // if(taskStatus == "REASSIGNED"){
    //   note = "Task ASSIGNED to " + name;
    // }
    note = "Task ASSIGNED to " + name;
    let body = {
      "taskId": Number(taskId),
      "userId": Number(userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(taskStatus),
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.addClass('assignedTo')
        this.getSingleTask(taskId);
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }



  updateStatus(taskId:any,){
    this.updatebutton = true
    let body = {
      "note": String(this.note),
      "taskStatus": String(this.taskStatus),
      "updatedDate": 0,
      "images": this.images,
      "audios": [],
      "videos": []
    }
    console.log(body);
    this.generic_service.updateStatus(body,taskId).subscribe(
      (response:any)=>{
        this.statusNote = false;
        this.getSingleTask(taskId);
        this.note = ''
        this.taskStatus = ""
        this.updatebutton = false
        console.log(response)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
        this.updatebutton = false
      }
    )
  }

  addClass(value:any){
    console.log(value)
    if(this.addClassType == ''){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      if(this.addClassType == value){
        let list = document.getElementById('assign-and-tag-data')
        if(list?.classList.contains('assign-show')){
          list.classList.remove('assign-show')
          this.addClassType = ''
        }else{
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      }else{
        this.addClassType = value
      }
    }
  }

  getTasksByStatus(status:any){
    this.taskType = status;
    this.addClassType = '';
    console.log(status)
    // this.generic_service.getTasksByStatus(status).subscribe(
    //   (res:any)=>{
    //     console.log(res)
    //     this.tasks = res.response;
    //     this.count = res.response.length;
    //   },
    //   (err:any)=>{
    //     console.log(err)
    //   }
    // )
  }

  // getTaskTypeCount(){
  //   this.generic_service.getAllTask().subscribe(
  //     (response:any)=>{
  //       let NEW = 0
  //       let ASSIGNED = 0
  //       let REASSIGNED = 0
  //       let WORK_IN_PROGRESS = 0
  //       let PENDING = 0
  //       let COMPLETED = 0
  //       let DEFERRED = 0
  //       let PARTIALLY_COMPLETED = 0
  //       let FORCE_CLOSED = 0
  //       let CLOSED = 0
  //       this.Total_tasksCount = response.response.length
  //       for(var i=0; i<response.response.length; i++) {
  //         if(response.response[i].latestStatus == 'NEW'){
  //           NEW++;
  //         }
  //         if(response.response[i].latestStatus == 'ASSIGNED'){
  //           ASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'REASSIGNED'){
  //           REASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'WORK_IN_PROGRESS'){
  //           WORK_IN_PROGRESS++;
  //         }
  //         if(response.response[i].latestStatus == 'PENDING'){
  //           PENDING++;
  //         }
  //         if(response.response[i].latestStatus == 'COMPLETED'){
  //           COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'DEFERRED'){
  //           DEFERRED++;
  //         }
  //         if(response.response[i].latestStatus == 'PARTIALLY_COMPLETED'){
  //           PARTIALLY_COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'FORCE_CLOSED'){
  //           FORCE_CLOSED++;
  //         }
  //         if(response.response[i].latestStatus == 'CLOSED'){
  //           CLOSED++;
  //         }
  //       }
  //       console.log(response)
  //       this.NEW_tasksCount = NEW
  //       this.ASSIGNED_tasksCount = ASSIGNED
  //       this.REASSIGNED_tasksCount = REASSIGNED
  //       this.WORK_IN_PROGRESS_tasksCount = WORK_IN_PROGRESS
  //       this.PENDING_tasksCount = PENDING
  //       this.COMPLETED_tasksCount = COMPLETED
  //       this.DEFERRED_tasksCount = DEFERRED
  //       this.PARTIALLY_COMPLETED_tasksCount = PARTIALLY_COMPLETED
  //       this.FORCE_CLOSED_tasksCount = FORCE_CLOSED
  //       this.CLOSED_tasksCount = CLOSED
  //     }
  //   )
  // }

  getSingleTask(id:any){
    console.log(id)
    this.generic_service.getSingleTask(id).subscribe(
      (res:any)=>{
        this.task = [];
        console.log(res);
        this.ticketId = res.response.ticketId
        this.ctid = res.response.ctid
        this.taskId = res.response.id;
        this.task.push(res.response);
        if(this.ticketId != null && this.ticketId != null){
          this.getSingleTicket(this.ticketId)
        }
        let arr:any = [];
        arr.push(Number(sessionStorage.getItem('userId')))
        let arr1:any = [];
        if(res.response.assignedTo != null && res.response.assignedTo != 0){
          arr1.push(res.response.assignedTo)
        }
        if(res.response.tagUsers.length != 0){
          for(let j=0; j<res.response.tagUsers.length; j++){
            arr.push(res.response.tagUsers[j].userid)
          }
        }
        let arr3 = arr.concat(arr1)
        this.userIdList = arr3
        this.userIdList = this.userIdList.filter((item,index) => this.userIdList.indexOf(item) === index);;
        console.log(this.userIdList)
      }
    )
  }


  insertConversation(){
    let body =  {
      "version": 0,
      "isActive": true,
      "description": "string",
      "id": 0,
      "conversationType": "TASK",
      "ticketTaskId": Number(this.taskId),
      "userIdList": this.userIdList,
      "remarks": "string",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.toastr.success(response.message)
        this.cancelModel()
        this.router.navigateByUrl('/admin/create-user')

      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
        this.cancelModel()
        this.router.navigateByUrl('/admin/create-user')

      }
    )
  }

  taskStatusDropdown(){
    console.log(this.taskStatus)

    if(this.taskStatus == "WORK_IN_PROGRESS"){
      this.note = "Started working on this"
    }
    if(this.taskStatus == "COMPLETED"){
      this.note = "Complteed the task"
    }
    if(this.taskStatus == "PENDING"){
      this.note = "Moving to Pending"
    }
    if(this.taskStatus == "DEFERRED"){
      this.note = "Moving to deffered"
    }
    if(this.taskStatus == "PARTIALLY_COMPLETED"){
      this.note = "Partially completed the task"
    }
    if(this.taskStatus == "FORCE_CLOSED"){
      this.note = "Closing the task due to"
    }
    if(this.taskStatus == "CLOSED"){
      this.note = "Task Closed"
    }

  }

  updateTaskPercentage(percentage:any,taskId:any){
    if(this.taskPercentage != percentage){
      console.log(percentage)
      let body = {
        "taskId": Number(taskId),
        "taskPercentage": Number(percentage)
      }
      this.generic_service.updateTaskPercentage(body).subscribe(
        (response:any)=>{
          console.log(response);
          this.getSingleTask(taskId)
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }

  TaskPercentage(percentage:any){
    this.taskPercentage = percentage
    console.log(this.taskPercentage)
  }

  clearForm(){
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  searchclear(){
    this.searchFilter = ""
    this.getAllTask()
  }

  taskFilterByWildSearch(searchKey:any){
    console.log(searchKey)
    console.log(searchKey.length)

    if(searchKey == ""){
      this.getAllTask()
    }else{
      this.generic_service.taskFilterByWildSearch(searchKey).subscribe(
        (response:any)=>{
          console.log(response)
          this.tasks = response.response;
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }
  getSingleTicket(id:any){
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res:any)=>{
        this.TicketData = [];
        this.TicketData.push(res.response.ticket);
        console.log(this.TicketData)
      }
    )
  }

  viewImage(image:string){
    this.videoSingle = ""
    this.vv = ""

    this.imageSingle = image
  }
  viewVideo(video:any){
    this.imageSingle = ""
    this.videoSingle = video
    this.vv = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoSingle);
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }
  
  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
  
    });
  }

  getActiveOrInactiveTasks(task:any){
    this.page = 0;
    if(task == 'All'){
      this.task_active_or_inactive = "All"
      this.getAllTask()
    }
    else if(task == 'Active'){
      this.task_active_or_inactive = "Active"
      this.getAllActiveTask(0,10)
    }else if(task == 'In-active'){
      this.task_active_or_inactive = "In-active"
      this.getAllNonActiveTask(0,10)
    }else{
      this.task_active_or_inactive = "NEW"
      this.getTasksByStatus(this.task_active_or_inactive)
    }
  }

  getAllActiveTask(pageNumber:any,recordsPerPage:any){
    this.generic_service.getAllActiveTask(pageNumber,recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.tasks = res.response.taskList;
        this.count = res.response.totalRecords
      }
    )
  }

  getAllNonActiveTask(pageNumber:any,recordsPerPage:any){
    this.generic_service.getAllNonActiveTask(pageNumber,recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.tasks = res.response.taskList
        this.count = res.response.totalRecords

      }
    )
  }

}